
export const RoleList = [
    {
        id: undefined,
        module: "account",
        moduleName: "Quản lý Tài khoản",
        roleView: false,
        roleCreate: false
    },
    {
        id: undefined,
        module: "weighingStation",
        moduleName: "Quản lý Trạm cân",
        roleView: true,
        roleCreate: false
    },
]
